export default __webpack_public_path__ + "cdd49c0c4a62d6ed345f96fa7339e8be.jpeg";